<script setup lang="ts">
// ラベル + スライダー + 数値入力。ドラッグ中は input、確定は change を出す (トランザクション用)。
const props = withDefaults(defineProps<{ label: string; value: number; min: number; max: number; step?: number; unit?: string }>(), { step: 1, unit: '' })
const emit = defineEmits<{ input: [v: number]; change: [v: number] }>()
function fmt(v: number) {
  return props.step >= 1 ? String(Math.round(v)) : v.toFixed(2)
}
function onNumber(e: Event) {
  const v = Number((e.target as HTMLInputElement).value)
  if (Number.isFinite(v)) emit('change', Math.max(props.min, Math.min(props.max, v)))
}
</script>

<template>
  <label class="sf">
    <span class="lbl">{{ label }}</span>
    <input type="range" :min="min" :max="max" :step="step" :value="value" @input="emit('input', Number(($event.target as HTMLInputElement).value))" @change="emit('change', Number(($event.target as HTMLInputElement).value))" />
    <input class="num mono" type="number" :min="min" :max="max" :step="step" :value="fmt(value)" @change="onNumber" />
    <span class="unit muted">{{ unit }}</span>
  </label>
</template>

<style scoped>
.sf {
  display: grid;
  grid-template-columns: 78px 1fr 56px 14px;
  align-items: center;
  gap: 6px;
  font-size: 11px;
}
.lbl {
  color: var(--fg-2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.num {
  width: 56px;
  padding: 2px 4px;
}
</style>
